import React from 'react';
import { routes } from '../../../constants';
import MasterLayout from '../../../components/AppLayout/MasterLayout';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import { Box } from '@mui/material';
import CourseCoverPageSummary from './CourseCoverPageSummary';
import CourseCoverPageCertificatesBanner from './CourseCoverPageCertificatesBanner';
import { CourseCoverPageProvider } from './CourseCoverPageProvider';
import useScreenSize from '../../../utils/useScreenSize';
import CourseCoverPageAuthors from './CourseCoverPageAuthors';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { IconName } from '../../../utils/getMuiIcon';
import searchResultsStorageManager from '../../../utils/searchResultsStorageManager';
import searchFiltersToQuery from '../../../utils/searchFiltersToQuery';
import { useTranslation } from 'react-i18next';

const CourseCoverPage = () => {
  const { isXsScreen } = useScreenSize();
  const { t } = useTranslation();

  const storageSessionCourseSearchFilters = searchResultsStorageManager.getCourseSearchFilters();
  const searchPageUrl = `/${routes.courseCatalog.root}?${searchFiltersToQuery(storageSessionCourseSearchFilters)}`;

  const summaryWrapperPadding = isXsScreen
    ? `${spaces.lg} ${spaces.md} ${spaces.xl} ${spaces.md}`
    : `${spaces.lg} ${spaces.xl} ${spaces.xxxl} ${spaces.xl}`;

  const bodyWrapperPadding = isXsScreen ?
    `${spaces.xl} ${spaces.md} ${spaces.xxxxxl} ${spaces.md}`
    : `${spaces.xxxl} ${spaces.xl} ${spaces.xxxxxl} ${spaces.xl}`;

  return (
    <MasterLayout
      customTopBarContent={<Breadcrumbs
        links={[
          {
            title: t('Search'),
            url: searchPageUrl,
            iconName: 'searchDone' as IconName,
          },
          {
            title: t('Course overview'),
            iconName: 'book' as IconName,
          },
        ]}
      />}
      forceNewNavigation
    >
      <CourseCoverPageProvider>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          margin: 'auto',
          backgroundColor: palette.background.paperElevation2,
          padding: summaryWrapperPadding,
        }}>
          <CourseCoverPageSummary />
        </Box>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          margin: 'auto',
          backgroundColor: palette.background.paperElevation1,
          padding: bodyWrapperPadding,
          gap: spaces.md
        }}>
          <CourseCoverPageCertificatesBanner />
          <CourseCoverPageAuthors />
        </Box>
      </CourseCoverPageProvider>
    </MasterLayout>
  );
};

export default CourseCoverPage;
